export enum EAuthButtonVariant {
  DIALOG_ONLY = 'DIALOG_ONLY',
  DIALOG_WITH_REDIRECT_TO_SEPARATE_REGISTRATION_PAGE = 'DIALOG_WITH_REDIRECT_TO_SEPARATE_REGISTRATION_PAGE',
}

export const TIMEOUT_TO_GET_FEATURE_FLAG = 500

export const USE_NEW_REGISTRATION_PAGE_FEATURE_FLAG = 'useNewRegistration'
